(function () {
    angular.module('caseStudyResource', ['ngResource'])
        .factory('caseStudyResource', caseStudyResource);

    caseStudyResource.$inject = ['$resource'];
    function caseStudyResource($resource) {
        return {
            list: $resource('/api/related-case-study'),
            services: $resource('/api/case-study/services/:id', { id: '@id' }),
            industries: $resource('/api/case-study/industries/:id', { id: '@id' })
        };
    }
})();